module.exports = __webpack_public_path__ + "static/media/plug.da85a7b7.svg";